import { APP_IMG } from 'src/constants';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { useRouter } from 'next/router';
const WidgetFollow = dynamic(import('src/components/widgets/widget-follow'));
const FooterTPPA = () => {
  const router = useRouter();
  return (
    <FooterWrapper id='ABOUT_US'>
      <div className='footer'>
        <div className='widget-socail'>
          <WidgetFollow
            //! DATALAYER
            eventDataLayer={{
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              section: 'follow',
              position: 'on:footer'
            }}
          />
        </div>
        <div className='copy-rights'>
          <span className='text'>{'Ⓒ THE PEOPLE All RIGHTS RESERVED.'}</span>
          <div className='image-logo'>
            <a href='/'>
              <img src={`${APP_IMG}/images/tppa/logo-tppa-white.png`} alt='logo-header' width={200} height='100%' />
            </a>
          </div>
        </div>
      </div>
    </FooterWrapper>
  );
};

export default FooterTPPA;

const FooterWrapper = styled.footer`
  padding: 20px 0;
  background-color: #ea1b3c;
  background-repeat: repeat;
  @media (max-width: 768px) {
    padding: unset;
  }
  .footer {
    width: 1300px;
    max-width: 100%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    padding: 15px;
    text-align: center;
    @media (max-width: 768px) {
      display: block;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
    .widget-socail {
      padding-top: 10px;
      text-align: center;
      justify-content: center;
      display: flex;
      padding-bottom: 15px;
    }
    .text {
      color: #ffffff;
      font-weight: 200;
      right: 25%;
      padding-right: 20px;

      /* position: absolute; */
      margin-top: 25px;
      @media (max-width: 768px) {
        padding-right: unset;
      }
      @media (max-width: 320px) {
        font-size: 14px;
      }
    }
    .copy-rights {
      display: flex;
      justify-content: center;
    }
    .image-logo {
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
`;
